import { render, staticRenderFns } from "./NotificationsManager.vue?vue&type=template&id=1de5175d&"
import script from "./NotificationsManager.vue?vue&type=script&lang=ts&"
export * from "./NotificationsManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports